import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import SVGTitle from "./SVGTitle";

function OurMessage() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <div
      className="our-message border-bottom border-top border-2 bg-white py-5 my-5 overflow-hidden"
      id="our-message"
      dir={isArabic ? "rtl" : "ltr"}
    >
      <Helmet>
        <title>{t("ourMessage.seo.title")}</title>
        <meta name="description" content={t("ourMessage.seo.description")} />
        <meta name="keywords" content={t("ourMessage.seo.keywords")} />

        <meta property="og:title" content={t("ourMessage.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("ourMessage.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://slimsmile.ps/assets/ourMessage.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={isArabic ? "ar_AR" : "en_US"} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: t("ourMessage.schema.name"),
            description: t("ourMessage.schema.description"),
          })}
        </script>
      </Helmet>

      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder"> {t("ourMessage.title")}</h2>
        <SVGTitle />
      </div>
      <div className="container my-5">
        <div className="row align-items-center flex-column-reverse flex-md-row">
          <motion.div
            className={`col-md-6 $`}
            style={{ color: "#222" }}
            initial={{ opacity: 0, x: isArabic ? 100 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h4 className="fw-bold" style={{ color: "#00b3ff" }}>
              {t("ourMessage.vision.title")}
            </h4>
            <p style={{ fontSize: "1.1rem", lineHeight: "1.9" }}>
              {t("ourMessage.vision.text")}
            </p>

            <h4 className="fw-bold mt-4" style={{ color: "#00b3ff" }}>
              {t("ourMessage.mission.title")}
            </h4>
            {t("ourMessage.mission.paragraphs", { returnObjects: true }).map(
              (p, idx) => (
                <p
                  key={idx}
                  style={{ fontSize: "1.1rem", lineHeight: "1.9" }}
                  dangerouslySetInnerHTML={{ __html: p }}
                />
              )
            )}

            <h5 className="mt-3 fw-bold" style={{ color: "#00b3ff" }}>
              {t("ourMessage.footer")}
            </h5>
          </motion.div>

          <motion.div
            className={`col-md-6 d-flex mb-5 mb-md-0`}
            initial={{ opacity: 0, x: isArabic ? -100 : 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <img
              src="assets/ourMessage.jpg"
              alt={t("ourMessage.imageAlt")}
              className="img-fluid rounded-4"
              style={{ maxHeight: "450px", objectFit: "cover" }}
              loading="lazy"
              decoding="async"
              width="600"
              height="450"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default OurMessage;
